import axios from "axios";
import { getCookie } from "../getcookie.js";

//URLs
const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
const apiUrl = process.env.REACT_APP_API_URL;
const apiMeetUrl = process.env.REACT_APP_MEETQ_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

// 1. Location
export const getLocationApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_location?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching location:", err);
  }
};

// 2. Department
export const getDepartmentApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_department?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching department:", err);
  }
};

// 3. Type
export const getTypeApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `getAssettype?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching type:", err);
  }
};

// 4. Report Type
export const getReportTypeApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_report_type?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching report type:", err);
  }
};

// 5. Status
export const getStatusApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_status?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching status:", err);
  }
};

// 6. Managed By
export const getManagedByApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_employee?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching managed by:", err);
  }
};

// 7. Used By
export const getUsedByApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_employee?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching used by:", err);
  }
};

//8. Report
export const getQuickReportApi = async () => {
  try {
    const response = await axios.get(apiUrl + `report/get_quick_report`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching quick report:", err);
  }
};

//9. Export Quick Report
export const exportQuickReportApi = async (reportType, fromDate, toDate) => {
  try {
    const response = await axios.post(
      apiUrl + "report/" + reportType,
      {
        from_date: fromDate,
        to_date: toDate,
      },
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error exporting quick report:", err);
    return err.response;
  }
};

//10. Download Custom Report
export const downloadCustomReportApi = async (reportType, data) => {
  try {
    const response = await axios.post(apiUrl + reportType, data, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error downloading custom report:", err);
    return err.response;
  }
};
